import { useTheme } from '@mui/material';

export const IntroIcon3 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
        >
            <path
                d="M8.75 10H8V10.75V30.25V31H8.75H31.25H32V30.25V13.75V13H31.25H13.25H12.5V14.5H13.25H30.5V29.5H9.5V11.5H29.75H30.5V10H29.75H8.75ZM26 23.125C26.2984 23.125 26.5845 23.0065 26.7955 22.7955C27.0065 22.5845 27.125 22.2984 27.125 22C27.125 21.7016 27.0065 21.4155 26.7955 21.2045C26.5845 20.9935 26.2984 20.875 26 20.875C25.7016 20.875 25.4155 20.9935 25.2045 21.2045C24.9935 21.4155 24.875 21.7016 24.875 22C24.875 22.2984 24.9935 22.5845 25.2045 22.7955C25.4155 23.0065 25.7016 23.125 26 23.125Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
